import DeviceActionsPage from "./DeviceActionsPage.svelte";

window.DeviceActions = (options) => {
    return new DeviceActionsPage(options);
}